import { render, staticRenderFns } from "./LeaveForm.vue?vue&type=template&id=11913838&scoped=true&"
import script from "./LeaveForm.vue?vue&type=script&lang=js&"
export * from "./LeaveForm.vue?vue&type=script&lang=js&"
import style0 from "./LeaveForm.vue?vue&type=style&index=0&id=11913838&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11913838",
  null
  
)

export default component.exports